import { render, staticRenderFns } from "./LegacyQueryBar.vue?vue&type=template&id=06c5f293&scoped=true&"
import script from "./LegacyQueryBar.vue?vue&type=script&lang=js&"
export * from "./LegacyQueryBar.vue?vue&type=script&lang=js&"
import style0 from "./LegacyQueryBar.vue?vue&type=style&index=0&id=06c5f293&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c5f293",
  null
  
)

export default component.exports